import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=52184ea4&scoped=true&"
import script from "./AppSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=52184ea4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52184ea4",
  null
  
)

export default component.exports